import clsx from "clsx";
import { SectionTitle } from "components/atoms/Text";
import LinkedInCard from "components/organism/Cards/LinkedInCard";
import { linkedinProxyBenefit } from "data/proxies";

const Benefits = () => {
    return (
        <section className={clsx(
            "w-full max-w-[1440px] mx-auto",
            "px-6 tablet:px-8 desktop:px-[120px] phone:py-12 tablet:py-16 desktop:pt-[88px] desktop:pb-[106px]",
        )}>
            <div className="w-full max-w-[760px] mx-auto">
                <SectionTitle classNames="text-center phone:!leading-[48px] tablet:!leading-[54px]">Buy Cheap, Dedicated and Fully Anonymous Proxies for LinkedIn</SectionTitle>
                <p className="max-w-[667px] mx-auto text-center font-normal relative z-30 phone:text-md text-neutral-50 text-md tracking-text !leading-[27.2px]">
                    LinkedIn is a very popular social platform for business relations. It's so popular that many are using it to get hired or recruit people. Many users are looking for shortcuts, automation and for ways to achieve their goals in a shorter time. The problem, as always, is that automation and the usage of such tools are prohibited, banned or restricted down to a level that makes it "fair for everyone".
                </p>
            </div>

            <div className="w-full mx-auto flex flex-col md:flex-row justify-center gap-10 phone:gap-6 tablet:gap-6 phone:mt-10 mt-16 tablet:mt-14">
                {linkedinProxyBenefit.map((item) => (
                    <LinkedInCard key={item.id} images={item.images} title={item.title} description={item.description} />
                ))}
            </div>
        </section>
    );
};

export default Benefits;